import { fileCirclePlus } from "@simplybusiness/icons";
import { Flex, Icon, Text } from "@simplybusiness/mobius";

type FileCirclePlusProps = {
  text: string;
};

export const FileCirclePlus = ({ text }: FileCirclePlusProps) => (
  <Flex className="mobius-quote-card__file-circle-plus" gap="xs">
    <Icon
      icon={fileCirclePlus}
      size="sm"
      color="var(--color-text)"
      title="Additional coverage available"
    />
    <Text variant="small">{text}</Text>
  </Flex>
);
